/**
 * Rewrites Supabase storage URLs to go through the configured proxy (Cloudflare Worker).
 * This ensures images load on networks that block *.supabase.co directly.
 */
export function getProxiedImageUrl(url) {
  if (!url) return url;
  const proxyBase = process.env.REACT_APP_SUPABASE_URL;
  if (!proxyBase) return url;
  // Replace the supabase.co host with our proxy host
  return url.replace(/https:\/\/[a-z0-9-]+\.supabase\.co/, proxyBase.replace(/\/$/, ''));
}
